import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default, { useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { View, StyleSheet } from 'react-native';
import { useBlurOnFulfill, useClearByFocusCell, CodeField, Cursor } from 'react-native-confirmation-code-field';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppText } from './index-6b88191c.esm.js';

// interface AppCodeInputProps {
//   /**
//    * Sets the main caption to describe the choice the user has to make
//    */
//   caption?: string;
//   /**
//    * Sets the sub caption to describe the choice the user has to make in details
//    */
//   subCaption?: string;
//   /**
//    * Background colour of the button used for the cancellation
//    */
//   cancelButtonColor?: string;
//   /**
//    * Label of the button used for the cancellation
//    */
//   cancelButtonLabel?: string;
//   /**
//    * Event raised when the user presses the cancel button
//    */
//   onCancelButtonPress?: () => void;
//   /**
//    * Background colour of the button used for the confirmation
//    */
//   confirmButtonColor?: string;
//   /**
//    * Label of the button used for the confirmation
//    */
//   confirmButtonLabel?: string;
//   /**
//    * Style applied to the caption text
//    */
//   captionStyle?: StyleProp<ViewStyle>;
//   /**
//    * Style applied to the sub-caption text
//    */
//   subCaptionStyle?: StyleProp<ViewStyle>;
//   /**
//    * Style applied to the caption wrapper of the underlying AppText
//    */
//   captionWrapperStyle?: StyleProp<ViewStyle>;
//   /**
//    * Style applied to the sub-caption wrapper of the underlying AppText
//    */
//   subCaptionWrapperStyle?: StyleProp<ViewStyle>;
//   /**
//    * Style applied to wrapper of all sub-components
//    */
//   wrapperStyle?: StyleProp<ViewStyle>;
//   rootStyle?: StyleProp<ViewStyle>;
//   AppChoiceButton?: any;
//   confirmCaption?: string;
//   cancelCaption?: string;
//   children?: React.ReactNode;
//   value?: string;
//   setValue?: (value: string) => void;
//   cellCount?: number;
//   numbersOnly?: boolean;
// }

const AppCodeInput = _ref => {
  let {
    caption,
    subCaption,
    cancelButtonColor,
    cancelButtonLabel = "Cancel",
    confirmButtonColor,
    confirmButtonLabel = "Confirm",
    captionStyle,
    subCaptionStyle,
    captionWrapperStyle,
    subCaptionWrapperStyle,
    wrapperStyle,
    confirmCaption,
    cancelCaption,
    children,
    value,
    setValue,
    cellCount = 6,
    rootStyle,
    numbersOnly = true,
    ...otherProps
  } = _ref;
  const ref = useBlurOnFulfill({
    value,
    cellCount
  });
  const [props, getCellOnLayoutHandler] = useClearByFocusCell({
    value,
    setValue
  });
  const {
    currentTheme,
    mode
  } = useTheme();
  const styles = generateStyles(currentTheme);
  useTranslation();
  useEffect(() => {
    // if value contains letters or special characters return an empty string
    if (value && (value === null || value === void 0 ? void 0 : value.length) === cellCount && numbersOnly && !/^[0-9]*$/.test(value)) {
      setValue("");
    }
  }, [value]);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [styles.wrapper, wrapperStyle]
  }, /*#__PURE__*/React__default.createElement(AppText, {
    wrapperStyle: [styles.captionWrapper, captionWrapperStyle],
    style: [styles.caption, captionStyle]
  }, caption), /*#__PURE__*/React__default.createElement(AppText, {
    wrapperStyle: [styles.subCaptionWrapper, subCaptionWrapperStyle],
    style: [styles.subCaption, subCaptionStyle]
  }, subCaption), /*#__PURE__*/React__default.createElement(CodeField, _extends({
    ref: ref
  }, props, {
    value: value,
    onChangeText: setValue,
    cellCount: cellCount,
    rootStyle: [styles.codeFieldRoot, rootStyle],
    keyboardType: "number-pad",
    textContentType: "oneTimeCode",
    autoCompleteType: "password",
    importantForAutofill: "no",
    renderCell: _ref2 => {
      var _currentTheme$theme;
      let {
        index,
        symbol,
        isFocused
      } = _ref2;
      return /*#__PURE__*/React__default.createElement(Fragment, {
        key: index
      }, /*#__PURE__*/React__default.createElement(AppText, {
        preventTranslation: true,
        key: "value-".concat(index),
        color: currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.white,
        style: [styles.cell, isFocused && styles.focusCell],
        onLayout: getCellOnLayoutHandler(index)
      }, symbol || (isFocused ? /*#__PURE__*/React__default.createElement(Cursor, null) : null)), index === 2 ? /*#__PURE__*/React__default.createElement(View, {
        key: "separator-".concat(index),
        style: styles.separator
      }) : null);
    }
  })));
};
const generateStyles = props => {
  var _props$theme, _props$theme2, _props$theme3, _props$theme4, _props$theme5, _props$theme6, _props$theme7;
  return StyleSheet.create({
    wrapper: {
      maxWidth: 400,
      justifyContent: "center"
    },
    caption: {
      fontFamily: "boldFont",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.large_font_size
    },
    captionWrapper: {
      justifyContent: "flex-start"
    },
    subCaptionWrapper: {
      justifyContent: "flex-start",
      paddingTop: 10
    },
    subCaption: {
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.small_font_size
    },
    choiceView: {
      paddingTop: 0,
      alignItems: "center"
    },
    root: {
      padding: 20,
      minHeight: 300
    },
    title: {
      textAlign: "center",
      fontSize: 30
    },
    codeFieldRoot: {
      marginTop: 20,
      width: 320,
      alignSelf: "center"
    },
    cell: {
      width: 35,
      height: 40,
      lineHeight: 35,
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.large_font_size,
      fontColor: props === null || props === void 0 ? void 0 : (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.font_color,
      borderWidth: 2,
      borderRadius: 6,
      borderColor: props === null || props === void 0 ? void 0 : (_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : _props$theme5.border_color,
      textAlign: "center"
    },
    separator: {
      height: 2,
      width: 10,
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme6 = props.theme) === null || _props$theme6 === void 0 ? void 0 : _props$theme6.border_color,
      alignSelf: "center"
    },
    focusCell: {
      borderColor: props === null || props === void 0 ? void 0 : (_props$theme7 = props.theme) === null || _props$theme7 === void 0 ? void 0 : _props$theme7.border_color
    }
  });
};
AppCodeInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppCodeInput",
  "props": {
    "cancelButtonLabel": {
      "defaultValue": {
        "value": "\"Cancel\"",
        "computed": false
      },
      "required": false
    },
    "confirmButtonLabel": {
      "defaultValue": {
        "value": "\"Confirm\"",
        "computed": false
      },
      "required": false
    },
    "cellCount": {
      "defaultValue": {
        "value": "6",
        "computed": false
      },
      "required": false
    },
    "numbersOnly": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppCodeInput as A };
